export enum KeyCode {
    ENTER = 'Enter',
    ESCAPE = 'Escape'
}
